import React, { useMemo, useEffect, useContext, useState } from 'react'
import * as classes from './Awards.module.scss'
import Container from '../../../ui/Container/Container'
import AwardCard from './AwardCard'
import { useDataAwards } from './useDataAwards'
import { deleteHtmlTag } from '../../../../utils/deleteHtmlTag'
import { useDataAwardsByEn } from './useDataAwardsByEn'
import { FormContext } from './../../../../context/index'
import { startAnimationScroll } from '../../../../utils/animations'
import splitRow from './../../../../utils/splitRow'
import splitTitleV2 from '../../../../utils/splitTitleV2'
import SectionTitle from '../../../ui/SectionTitle/SectionTitle'

function Awards({ lang }) {
    const dataByHy = useDataAwards()
    const dataByEn = useDataAwardsByEn()
    const data = lang === 'hy' ? dataByHy : dataByEn

    const title = useMemo(() => deleteHtmlTag(data.title.value, 'p'), [])

    const items = useMemo(
        () =>
            data.items.nodes.map((item) => {
                return {
                    year: item.year,
                    title: deleteHtmlTag(item.title, 'p'),
                    text: deleteHtmlTag(item.text, 'p'),
                    imageAlt: deleteHtmlTag(item.title, 'all').trim(),
                    certificate_image: item.certificateImage?.url,
                    badgeWidth: item.certificateImage?.width
                }
            }),
        []
    )

    const { animationStart } = useContext(FormContext)
    const [contentTopAnime, setContentTopAnime] = useState({ title })

    const classAnimationTitle = 'anime-title-awards'
    const classAnimationText = 'anime-text-awards'
    const classAnimationLine = 'anime-line-awards'

    useEffect(() => {
        if (animationStart) {
            splitRow(classAnimationText)
            splitTitleV2(classAnimationTitle)
        }

        const observer = startAnimationScroll([
            { type: 'title', className: classAnimationTitle },
            { type: 'text', className: classAnimationText },
            { type: 'lineVertical', className: classAnimationLine }
        ])

        return () => {
            if (observer) {
                observer.disconnect()
            }
        }
    }, [animationStart])

    return (
        <section className={classes.Section}>
            <Container>
                {contentTopAnime.title ? <SectionTitle className={classes.SectionTitle} title={contentTopAnime.title} lang={lang} /> : null}

                {items && items.length ? (
                    <div className={classes.Items}>
                        {items.map((item, index) => (
                            <AwardCard
                                key={index}
                                year={item.year}
                                title={item.title}
                                text={item.text}
                                image={item.certificate_image}
                                imageAlt={item.imageAlt}
                                badgeWidth={item.badgeWidth}
                            />
                        ))}
                    </div>
                ) : null}
            </Container>
        </section>
    )
}

export default Awards
